import Store from 'store/store';
import 'store/member';
import 'store/customTracking';
import { apiPrime } from 'utils/bolt/apiPrime';
import { getUserTickets } from 'helpers/tickets';


const CLIENT_ID = 'amzn1.application-oa2-client.55d73ce9d7fa4b128a8e63f3ae34703e';

const whitelistedTestEmail = 'uranup+primenew01@amazon.com';

const implementIdleTimeout = () => {
	const timeInMs = 10 * 60 * 1000;
	window.checkingForAmazonLoginIdle = window.setTimeout(() => {
		window.location.reload();
	}, timeInMs);
};

const clearIdleTimeout = () => {
	if (window.checkingForAmazonLoginIdle) {
		window.clearTimeout(window.checkingForAmazonLoginIdle);
	}
};

const getCookie = (name) => {
	let value = '; ' + document.cookie;
	let parts = value.split('; ' + name + '=');
	if (parts.length == 2) {
		return parts.pop().split(';').shift();
	}
};

export const loadSDK = () => {
	return new Promise((resolve, reject) => {
		let script = document.createElement('script');
		script.onload = resolve;
		script.onerror = reject;
		script.async = true;
		script.id = 'amazon-login-sdk';
		script.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
		document.getElementById('amazon-root').appendChild(script);
	});
};

export const setClientID = () => {
	window.amazon.Login.setClientId(CLIENT_ID);
	checkAlreadyAuthorised();
};

const checkAlreadyAuthorised = () => {
	let amazonLoginCookie = getCookie('amazon_Login_state_cache');
	if (!amazonLoginCookie) return;
	amazonLoginCookie = JSON.parse(decodeURIComponent(amazonLoginCookie));
	retrieveProfile(amazonLoginCookie.access_token);
};

const deleteAuthCookies = () => {
	document.cookie = 'amazon_Login_state_cache=; expires=Thu, 01 Jan 1970 00:00:01 UTC; path=/';
	document.cookie = 'amazon_Login_auth_code_scope_cache=; expires=Thu, 01 Jan 1970 00:00:01 UTC; path=/';
};

const retrieveProfile = (accessToken) => {
	window.amazon.Login.retrieveProfile(accessToken, async (response) => {
		if (response.error) {
			console.error('Error retrieving profile - ', response.error);
			Store.emit('SHOW_FULL_LOADER', false);
			return;
		}
		
		// check prime benefit status
		try {
			const benefitResponse = await apiPrime({
				method: 'get',
				path: '/get-user-benefits',
				query: {
					user_access_token: accessToken,
					region_code: Store.get()?.appData?.meta?.region?.slug || 'us'
				}
			});

			const isWhitelistedTestingAccount = response.profile?.PrimaryEmail === whitelistedTestEmail;

			const benefits = benefitResponse?.response?.data || [];
			if (!benefits.includes('PRIME_POWSTER_BENEFIT') && !isWhitelistedTestingAccount) {
				Store.emit('SHOW_PRIME_BLOCK', true);
				Store.emit('SHOW_FULL_LOADER', false);
				return;
			}
		} catch (err) {
			console.error('Error checking prime benefit - ', err);
			Store.emit('SHOW_FULL_LOADER', false);
			return;
		}

		const tickets = await getUserTickets(response.profile?.CustomerId);

		Store.emit('RETRIEVED_PROFILE', response.profile);
		Store.emit('RETRIEVED_USER_TICKETS', tickets);
		Store.emit('SHOW_FULL_LOADER', false);
		Store.emit('TRACK_AUTH_SUCCESS');
	});
};

export const startLogin = () => {
	Store.emit('SHOW_FULL_LOADER', true);
	let amazonLoginCookie = getCookie('amazon_Login_state_cache');
	if (amazonLoginCookie) {
		deleteAuthCookies();
	}
	implementIdleTimeout();

	const options = {
		scope: 'profile prime:benefit_status',
		pkce: true
	};
	window.amazon.Login.authorize(options, (response) => {
		clearIdleTimeout();
		if (response.error) {
			console.error('Error during Amazon authorisation - ', response.error);
			Store.emit('SHOW_FULL_LOADER', false);
			return;
		}
		window.amazon.Login.retrieveToken(response.code, (response) => {
			if (response.error) {
				console.error('Error retrieving access token - ', response.error);
				Store.emit('SHOW_FULL_LOADER', false);
				return;
			}
			retrieveProfile(response.access_token);
		});
	});
};

